export default __webpack_public_path__ + "static/media/details-pane-blue-icon.4df896e5.svg";